import script from "./courseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./courseItem.vue?vue&type=script&setup=true&lang=js"

import "./courseItem.vue?vue&type=style&index=0&id=ee84f344&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee84f344"]])

export default __exports__